import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main_div" }

import { ref } from "vue";
import { NSpace, NCard } from "naive-ui";

export default /*@__PURE__*/_defineComponent({
  __name: 'DashBoard',
  setup(__props) {

const componentKey = ref(0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("div", {
      style: {"height":"auto"},
      key: componentKey.value
    }, [
      _createVNode(_unref(NSpace), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("div", { style: {"font-size":"20px","width":"150px","font-weight":"bold"} }, "Dashboard", -1)
                ])),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _cache[2] || (_cache[2] = _createElementVNode("div", null, [
                _createElementVNode("p", null, "대쉬보드")
              ], -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})